(function ($) {

    $(document).ready(function () {

        $('.ua-firefox body .blog-grid').addClass("cl-firefox");
        $('.ua-ie body .blog-grid').addClass("cl-ie");
        $('.ua-edg body .blog-grid').addClass("cl-firefox");
        $('.ua-mobile .blog-grid').addClass("cl-touch");


        $(".blog-grid:not(.cl-touch) .filter-wrapper select.filter-1").selectBoxIt();

        $(".blog-grid:not(.cl-touch) .filter-wrapper select.filter-2").selectBoxIt();

        $(document).click(function () {
            $(" .blog-grid .filter ul li").removeClass("show");
            $(".blog-grid .filter-wrap-1 ul.selectboxit-options.selectboxit-list").css("visibility","hidden");
        });


        $(".blog-grid .filter-wrap-1 span.selectboxit-text").click(function () {
            setTimeout(function () {
                $(" .blog-grid .filter-wrap-1 ul li").toggleClass("show");
                $(".blog-grid .filter-wrap-1 ul.selectboxit-options.selectboxit-list").css("visibility","visible");
            },100);

        });
        $(".blog-grid .filter-wrap-2 span.selectboxit-text").click(function () {
            setTimeout(function () {
                $(" .blog-grid .filter-wrap-2 ul li").toggleClass("show");
                $(".blog-grid .filter-wrap-2 ul.selectboxit-options.selectboxit-list").css("visibility","visible");
            },100);

        });




    });

    $(document).ready(function () {

        // filters
        $(document).on('change', '.blog-grid .filter select', function (e) {

            var value = $(this).val();
            var value2 = $('#views-exposed-form-blog-block-2 .form-item-sort-order select').val();
            if (value !== value2) {
                $('#views-exposed-form-blog-block-2 .form-item-sort-order select').val(value).trigger('change');
                $('#views-exposed-form-blog-block-2 .form-submit').trigger('click');
            }
        });


    });

    $(".blog-grid .pager__item a ").click(function () {
        $( document).ajaxStart(function( event, xhr, settings ) {
            if((".blog-grid").length > 0) {
                var winWidth=$(window).width();
                if(winWidth>991) {
                    $('html,body').animate({
                        scrollTop: $(".blog-grid .col-wrapper").offset().top - 190
                    }, 500);
                }else {
                    $('html,body').animate({
                        scrollTop: $(".blog-grid .col-wrapper").offset().top - 140
                    }, 500);
                }

            }

        });
    });


})(jQuery);
